import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Badge, UncontrolledTooltip } from 'reactstrap';

const CsvFieldsList = ({ fields, t, tReady }) => {
  const requiredFields = fields.filter(
    (field) => !field.optional && field.required
  );
  const otherFields = fields.filter(
    (field) => field.optional || !field.required
  );

  return (
    <div className="csv-fields-list">
      <h6>{tReady && t('csv-file-fields')}</h6>
      <p className="text-muted mb-3">
        {tReady && t('csv-file-fields-description')}
      </p>

      <div className="d-flex flex-wrap gap-2 mb-3">
        {requiredFields.map((field, index) => (
          <Badge
            key={index}
            color="danger"
            className="d-flex align-items-center p-2"
          >
            <i
              className="ri-information-line me-2"
              style={{ cursor: 'pointer', fontSize: '14px' }}
              id={`required-field-info-${index}`}
            ></i>
            <UncontrolledTooltip
              placement="top"
              target={`required-field-info-${index}`}
            >
              {tReady && t(field.tooltipKey)}
            </UncontrolledTooltip>
            <span>{tReady && t(field.labelKey)}</span>
          </Badge>
        ))}

        {otherFields.map((field, index) => (
          <Badge
            key={index}
            color="light"
            className="d-flex align-items-center p-2 text-dark border"
          >
            <i
              className="ri-information-line text-info me-2"
              style={{ cursor: 'pointer', fontSize: '14px' }}
              id={`optional-field-info-${index}`}
            ></i>
            <UncontrolledTooltip
              placement="top"
              target={`optional-field-info-${index}`}
            >
              {tReady && t(field.tooltipKey)}
            </UncontrolledTooltip>
            <span>{tReady && t(field.labelKey)}</span>
          </Badge>
        ))}
      </div>
    </div>
  );
};

CsvFieldsList.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      labelKey: PropTypes.string.isRequired,
      descriptionKey: PropTypes.string,
      tooltipKey: PropTypes.string.isRequired,
      required: PropTypes.bool,
      optional: PropTypes.bool,
    })
  ).isRequired,
};

export default withTranslation()(CsvFieldsList);
